import React from "react";

import { storeEvent } from "_analytics/index";

import Presentation from "./presentation";

const component = ( {
	sportsFanDetails,
	toggleDialogInfoBox,
	source
} ) => {

	let profileHref, profileAs;

	if ( sportsFanDetails ) {
		profileHref = "/profile/[id]";
		profileAs   = `/profile/${ sportsFanDetails.id }`;
	}

	const handleFollowGAEvent = () => {
		storeEvent ( "Profile", sportsFanDetails.isFollowing === 0 ? "Follow" : "Unfollow", "Search" );
	};

	return (
		<Presentation
			handleFollowGAEvent = { handleFollowGAEvent }
			profileAs           = { profileAs }
			profileHref         = { profileHref }
			source              = { source }
			sportsFanDetails    = { sportsFanDetails }
			toggleDialogInfoBox = { toggleDialogInfoBox }
		/>
	);
};

export default component;
